import { folderOf, foldersFromPaths, isNote } from "./vault/paths";

export interface FileTreeRow {
  path: string;
  name: string;
  folder: boolean;
  parent: string | null;
  depth: number;
  prefix: string;
  expanded: boolean;
  position: number;
  siblings: number;
}

export function fileTreeRows(
  notes: readonly string[],
  folders: readonly string[],
  collapsed: Pick<ReadonlySet<string>, "has">,
): FileTreeRow[] {
  const children = new Map<string, { path: string; folder: boolean }[]>();
  const add = (path: string, folder: boolean) => {
    const parent = folderOf(path);
    const entries = children.get(parent) ?? [];
    entries.push({ path, folder });
    children.set(parent, entries);
  };
  const files = [...new Set(notes.filter(isNote))];
  foldersFromPaths(files, folders).forEach((path) => add(path, true));
  files.forEach((path) => add(path, false));
  for (const entries of children.values())
    entries.sort(
      (a, b) =>
        Number(b.folder) - Number(a.folder) || a.path.localeCompare(b.path),
    );
  const rows: FileTreeRow[] = [
    {
      path: "",
      name: "/",
      folder: true,
      parent: null,
      depth: 1,
      prefix: "",
      expanded: !collapsed.has(""),
      position: 1,
      siblings: 1,
    },
  ];
  const visit = (parent: string, depth: number, prefix: string) => {
    if (collapsed.has(parent)) return;
    const entries = children.get(parent) ?? [];
    entries.forEach((entry, index) => {
      const last = index === entries.length - 1;
      rows.push({
        ...entry,
        name: entry.path.split("/").at(-1)!,
        parent,
        depth,
        prefix: prefix + (last ? "└─ " : "├─ "),
        expanded: entry.folder && !collapsed.has(entry.path),
        position: index + 1,
        siblings: entries.length,
      });
      if (entry.folder)
        visit(entry.path, depth + 1, prefix + (last ? "   " : "│  "));
    });
  };
  visit("", 2, "");
  return rows;
}
